import { render, staticRenderFns } from "./ShibouDoukishoPreview.vue?vue&type=template&id=18d2549a"
import script from "./ShibouDoukishoPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShibouDoukishoPreview.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports